import { render, staticRenderFns } from "./Body.vue?vue&type=template&id=3084d127&scoped=true&"
import script from "./Body.vue?vue&type=script&lang=js&"
export * from "./Body.vue?vue&type=script&lang=js&"
import style0 from "./Body.vue?vue&type=style&index=0&id=3084d127&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3084d127",
  null
  
)

export default component.exports